import { useMemo } from 'react';

import type { ItemList } from 'schema-dts';

import { useTopicPageData, useTopicPagePaginatedTrendingPetitionsData } from 'src/app/pages/topic/pageContext';
import { jsonLd } from 'src/app/shared/utils/jsonLd';

type Result = ModelHookResult<{
	displayed: boolean;
	schemaJson: string | undefined;
}>;

export function useMetaPetitionItemList(): Result {
	const {
		data: { name },
	} = useTopicPageData();

	const {
		data: { items, totalCount },
	} = useTopicPagePaginatedTrendingPetitionsData();

	const displayed = !!items.length;

	const itemList = useMemo(
		() =>
			jsonLd<ItemList>({
				'@context': 'https://schema.org',
				'@type': 'ItemList',
				name: `Petitions in ${name}`,
				numberOfItems: totalCount,
				itemListElement: items.map((item, index) => ({
					'@type': 'ListItem',
					position: index + 1,
					url: `https://change.org/p/${item.node.slug}`,
					name: item.node.ask,
					description: item.node.description, // TODO: do we want to truncate description to X characters?
				})),
			}),
		[items, name, totalCount],
	);

	return {
		data: {
			displayed,
			schemaJson: displayed ? itemList : undefined,
		},
	};
}
